export default "__VITE_ASSET__B9C2FjAD__"